import React from "react";
import Modal from "../../components/ui/Modal";
import FormMoreInfo from "../../components/FormMoreInfo/FormMoreInfo";
import useLang from "../../i18n/useLang";
import content from "./content";

const ModalMoreInfoSerp = ({
  modalBusinessInfo,
  setModalBusinessInfo,
  onLocalSearchSubmit,
  location,
}) => {
  const t = content[useLang()];
  const handleSubmit = async (data) => {
    await onLocalSearchSubmit(location, data);
  };

  return (
    <Modal
      title={t.modalTitle}
      visible={modalBusinessInfo}
      onClose={() => setModalBusinessInfo(false)}
    >
      <FormMoreInfo onSubmit={handleSubmit} />
    </Modal>
  );
};

export default ModalMoreInfoSerp;
